import Components from './../Component';

export default class ViewMore extends Components {

  constructor($) {
    super($);
  }

  init(index, element) {
    this.$(element).find('.view-more-button a').on('click', function (e) {
      this.$(element).addClass('show');
      return false;
    }.bind(this));
  }
}